import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TbillBillService {
    tbillBill: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'tbill_bill/list/?';
    private Finalbillchack = webapi + 'tbill_bill/finalbillchack/';
    private AddRecord = webapi + 'tbill_bill/create';
    private updateRecord = webapi + 'tbill_bill/reconciliation';
    private AddReconciliationRecord = webapi + 'tbill_reconciliation_log/create';
    private AddRecordBillService = webapi + 'tbill_service/create';
    private AddIPDRecordBillService = webapi + 'tbill_service/createIPD';
    private AddIPDRecordBillServiceById = webapi + 'tbill_service/createIPDByMibillIpd/';
    private updateIPDRecordBillService = webapi + 'tbill_service/updateIPD';
    private pushIPDdataFullinOnego = webapi + 'tbill_service/billbyid/';
    private EditRecord = webapi + 'tbill_bill/update';
    private EditchargeRecord = webapi + 'tbill_charge/update';
    private GetRecord = webapi + 'tbill_bill/byid/';
    private DeletechargeserviceRecord = webapi + 'tbill_charges_services/delete/';
    private CancelTbillService = webapi + 'tbill_service/CancelService/';
    private DeleteRecord = webapi + 'tbill_bill/delete/';
    private LastRecord = webapi + 'tbill_bill/lastrecord';
    private ListByDateRecord = webapi + 'tbill_bill/listbydate/?';
    private ListIpdBillSearchRecord = webapi + 'tbill_bill/listipdbillsearch/?';
    private ListlatestIpdBillSearch = webapi + 'tbill_bill/listoflatestipdbill/?';
    private OpenBill = webapi + 'tbill_bill/listoflatestipdbill/?';
    private CloseBill = webapi + 'tbill_bill/listoflatestipdbill/?';
    private ListIpdBillSearchMRRecord = webapi + 'tbill_bill/listipdbillsearchbymr/?';
    private ListIpdBillSearcNamehRecord = webapi + 'tbill_bill/listipdbillsearchbyname/?';
    private ListIpdBillSearchMobilRecord = webapi + 'tbill_bill/listipdbillsearchbymobile/?';
    private ListIpdBillSearchPhoneRecord = webapi + 'tbill_bill/listipdbillsearchbyphone/?';
    private ListIpdBillSearchIdRecord = webapi + 'tbill_bill/listipdbillsearchbyid/?';
    private ListIpdBillSearchMailRecord = webapi + 'tbill_bill/listipdbillsearchbymail/?';
    private IpdBillBypatientRecord = webapi + 'tbill_bill/ipdbillbypatient/?';
    private OpdBillBypatientRecord = webapi + 'tbill_bill/opdbillbypatient/?';
    private cancelledOpdBillBypatientRecord = webapi + 'tbill_bill/cancelledOpdBillBypatientRecord/?';
    private Ipdbilllistbypatient = webapi + 'tbill_bill/ipdbilllistbypatient/?';
    private CancelledIpdbilllistbypatient = webapi + 'tbill_bill/cancelledipdbilllistbypatient/?';
    private Ipdbilllistbyadmission = webapi + 'tbill_bill/ipdbilllistbyadmission/?';
    private RadiologyOrderList = webapi + 'tbill_bill/radiologyorderlist?';
    private LabOrderList = webapi + 'tbill_bill/pathologyorderlist?';
    private listByMrNumber = webapi + 'tbill_bill/listbymrnumber/?';
    private EditRecordBillOutstanding = webapi + 'tbill_bill/updatebilloutstanding';
    private EditRecordIPDBillOutstanding = webapi + 'tbill_bill/updateipdbilloutstanding';
    private EditIpdBill = webapi + 'tbill_bill/updateipdbill';
    private AddIpdChargeBill = webapi + 'tbill_charge/create';
    private searchIpdChargeBillByAdmission = webapi + 'tbill_charge/lisbyAdmissionId/?';
    private IpdChargeserviceslistBychargeId = webapi + 'tbill_charges_services/getservicesbychargeid/?';
    private IpdChargeserviceslistBychargeIdServiceName = webapi + 'tbill_charges_services/getservicesbychargeidservicename/?';
    private IpdunbilledChargeserviceslistBychargeId = webapi + 'tbill_charges_services/getunbilledservicesbychargeid/?';
    private CancelBill = webapi + 'tbill_bill/cancelbill/';
    private ListRecordById = webapi + 'tbill_bill/listByUnitId/?';
    private billListDoctorShare = webapi + 'tbill_bill/billListDoctorShare/?';
    private getAutoChargeListRecord = webapi + 'mbillipdbillcharges/ipd_bill_list/?';
    private updateAutochargeRecord = webapi + 'mbillipdbillcharges/ipd_billAutoCharges_PullUpdate/?';
    private checkIfBillIsFinalized = webapi + 'tbill_bill/check_if_bill_is_finalized/';
    private finalBilltoItermediate = webapi + 'tbill_bill/finaltointermediate/';
    private finalBilldatechange = webapi + 'tbill_bill/finalbillchange/';
    private checkIfBilloutstanding = webapi + 'tbill_bill/outstandingcheck/';
    private checkIfBilloutstandingEMG = webapi + 'tbill_bill/outstandingcheckEmg/';
    private getallservicebyadmission = webapi + 'tbill_service/allservices/';
    private GetallservicesDateWise = webapi + 'tbill_service/allservicesDateWise/';
    private getallservicebyadmission1 = webapi + 'tbill_service/allservices/consolation/';
    private getchargeserviceupdate = webapi + 'mbillipdbillcharges/update_ipd_charge/';
    private AddRecordBillServiceIndivisual = webapi + 'tbill_service/createIndivisual';
    private AddRecordBillServiceIndivisualForEMR = webapi + 'tbill_service/createIndivisualForEMR';
    private SetNewTokenNumber = webapi + 'tbill_service/SetNewTokenNumber';
    private updateIPDRecord = webapi + 'tbill_service/updateIPD';
    private consolidatedbillservice = webapi + 'tbill_service/servicelist/';
    private changereceiptsandcancelbill = webapi + 'tbill_bill/cancelbillandchangereceipt/';
    private changereceipts = webapi + 'tbill_bill/changereceipt/';
    private companyBill = webapi + 'bill_settelment/companyBillList/?';
    private settleBill = webapi + 'bill_settelment/settleBillList/?';
    private packageService = webapi + 'mbill_package/byid/';
    private packageByid = webapi + 'mbill_package/byMbillPackageid/';
    private package = webapi + 'mbill_package/autocomplete/';
    private ModifyBillRecord = webapi + 'tbill_bill/modifyBill';
    private GetOPDBillList = webapi + 'tbill_bill/getOPDBillList/';
    private GetIPDBillList = webapi + 'tbill_bill/getIpdBillList/';
    private packageBillView = webapi + 'package_view/create/';
    private packageView = webapi + 'package_view/view/';
    private packageView1 = webapi + 'package_view/viewCharge/';
    private groupDisAddOrUpdate = webapi + 'groupwisediscount/create/';
    private getGroupDisAdd = webapi + 'groupwisediscount/getByAdmissionId/';
    private getGroupDisBillId = webapi + 'groupwisediscount/getByBillId/';
    private changecancel = webapi + 'tbill_bill/cancelbill/';

    constructor(private http: Http) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
        return this.http.get(this.ListRecordById + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllRecordServiceDoctror(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
        return this.http.get(this.billListDoctorShare + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllCompanyRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
        return this.http.get(this.companyBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllCompany1RecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, companyName: any, mrNo: any, billNo: any): Promise<any> {
        return this.http.get(this.companyBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col + '&companyName=' + companyName + '&mrNo=' + mrNo + '&billNo=' + billNo)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCompanyRecordBycompanNameService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, companyName: any): Promise<any> {
        return this.http.get(this.companyBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col + '&companyName=' + companyName)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updatebillcancel(billId: any) {
        return this.http.get(this.changecancel + billId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordBymrNoNameService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, mrNo: any, name: any, admFromDate: any, admToDate: any, billFromDate: any, billToDate: any): Promise<any> {
        return this.http.get(this.companyBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col + '&mrNo=' + mrNo + '&name=' + name + '&adfromdate=' + admFromDate + '&adtodate=' + admToDate + '&billfromdate=' + billFromDate + '&billtodate=' + billToDate)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordBybillNoService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, billNo: any, admissionFromDate: any, admissionToDate: any, dischargeFromDate: any, dischargeToDate: any): Promise<any> {
        return this.http.get(this.companyBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col + '&billNo=' + billNo)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllCompanySettleBillListUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
        return this.http.get(this.settleBill + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&unitId=' + unitId + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordByMRService(mrNumber: any, currentPage: any, size: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.listByMrNumber + 'mrNumber=' + mrNumber + '&page=' + currentPage + '&size=' + size + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllByDateRecordService(currentPage: any, size: any, date: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListByDateRecord + 'page=' + currentPage + '&size=' + size + '&date=' + date + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    savePackageBillView(pkgBill: any, billId, chargeId): Promise<any> {
        return this.http.post(this.packageBillView + billId + '/' + chargeId, JSON.stringify(pkgBill), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateRecordService(model: any) {
        return this.http.post(this.updateRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordReconciliation(model: any) {
        return this.http.post(this.AddReconciliationRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordServiceBillService(model: any) {
        return this.http.post(this.AddRecordBillService, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordServiceBillServiceIndivisual(model: any) {
        return this.http.post(this.AddRecordBillServiceIndivisual, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordServiceBillServiceIndivisualForEMR(model: any) {
        return this.http.post(this.AddRecordBillServiceIndivisualForEMR, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addIPDRecordServiceBillService(model: any) {
        return this.http.post(this.AddIPDRecordBillService, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addIPDRecordServiceBillServiceByMbillId(model: any, id: any) {
        if (id == undefined) {
            return this.http.post(this.AddIPDRecordBillService, JSON.stringify(model), {headers: this.headers})
                .toPromise()
                .then(response => response.json())
                .catch(this.handleError);
        } else {
            return this.http.post(this.AddIPDRecordBillServiceById + id, JSON.stringify(model), {headers: this.headers})
                .toPromise()
                .then(response => response.json())
                .catch(this.handleError);
        }
    }

    pushIPDBillDataInOneGo(id: any) {
        return this.http.post(this.pushIPDdataFullinOnego + id, {headers: this.headers})
                .toPromise()
                .then(response => response.json())
                .catch(this.handleError);
    }

    updateIPDRecordServiceBillService(model: any) {
        return this.http.post(this.updateIPDRecordBillService, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editchargeRecordService(model: any) {
        return this.http.put(this.EditchargeRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordBillOutstanding(model: any) {
        return this.http.put(this.EditRecordBillOutstanding, model, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordIPDBillOutstanding(model: any) {
        return this.http.put(this.EditRecordIPDBillOutstanding, model, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editIPDRecord(model: any) {
        return this.http.put(this.EditIpdBill, model, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addIPDChargeRecord(model: any) {
        return this.http.put(this.AddIpdChargeBill, model, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deletechargeserviceRecordService(id: any, remark: any) {
        return this.http.put(this.DeletechargeserviceRecord + id, remark, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deletechargeserviceRecordService1(id: any, remark: any) {
        return this.http.put(this.DeletechargeserviceRecord + id, JSON.stringify(remark), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    cancelTbillService(id: any, remark: any) {
        return this.http.put(this.CancelTbillService + id, JSON.stringify(remark), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    cancelBillService(id: any) {
        return this.http.put(this.CancelBill + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        console.log('billId in service file get request::', id);
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getFinalbillchack(id: any) {
        return this.http.get(this.Finalbillchack + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    public getLastBill(qString: any) {
        return this.http.get(this.LastRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearch(qString: any) {
        return this.http.get(this.ListIpdBillSearchRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getListlatestIpdBillSearch(id: any) {
        return this.http.get(this.ListlatestIpdBillSearch + 'id=' + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    openBillService(id: any) {
        return this.http.get(this.OpenBill + 'id=' + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    closeBillService(id: any) {
        return this.http.get(this.CloseBill + 'id=' + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchMr(qString: any) {
        return this.http.get(this.ListIpdBillSearchMRRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchName(qString: any) {
        return this.http.get(this.ListIpdBillSearcNamehRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchMoile(qString: any) {
        return this.http.get(this.ListIpdBillSearchMobilRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addupdatedServiceBillService(model: any) {
        return this.http.post(this.updateIPDRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchPhone(qString: any) {
        return this.http.get(this.ListIpdBillSearchPhoneRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchId(qString: any) {
        return this.http.get(this.ListIpdBillSearchIdRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillSearchMail(qString: any) {
        return this.http.get(this.ListIpdBillSearchMailRecord + 'qstring=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBillBypatient(qString: any) {
        return this.http.get(this.IpdBillBypatientRecord + 'patientid=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getOpdBillBypatient(qString: any, unitid: any) {
        return this.http.get(this.OpdBillBypatientRecord + 'patientid=' + qString + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCancelledOpdBillBypatient(qString: any, unitid: any) {
        return this.http.get(this.cancelledOpdBillBypatientRecord + 'patientid=' + qString + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBilllistBypatient(qString: any, unitid: any) {
        return this.http.get(this.Ipdbilllistbypatient + 'patientid=' + qString + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCancelledIpdBilllistBypatient(qString: any, unitid: any) {
        return this.http.get(this.CancelledIpdbilllistbypatient + 'patientid=' + qString + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdBilllistByadmission(qString: any, unitid: any) {
        return this.http.get(this.Ipdbilllistbyadmission + 'admissionid=' + qString + '&unitid=' + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRadiologyOrderList(dept: any, currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.RadiologyOrderList + 'dept=' + dept + '&page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLabOrderList(dept: any, currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.LabOrderList + 'dept=' + dept + '&page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdChargelistByadmission(currentPage: any, size: any, qString: any, sort: any, col: any, AdmissionId: any) {
        return this.http.get(this.searchIpdChargeBillByAdmission + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&admissionId=' + AdmissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdChargeserviceslistBychargeId(ipdchargeId: any) {
        return this.http.get(this.IpdChargeserviceslistBychargeId + 'ipdchargeId=' + ipdchargeId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdChargeserviceslistBychargeIdServiceName(ipdchargeId: any, qString: any) {
        return this.http.get(this.IpdChargeserviceslistBychargeIdServiceName + 'ipdchargeId=' + ipdchargeId + '&qString=' + qString)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdconsolidatedserviceslistBychargeId(Billadmission: any) {
        console.log('get Ipd consolidate dservice slistBy chargeId in service get request::', Billadmission);
        return this.http.get(this.consolidatedbillservice + Billadmission)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updatebillsandreceipt(billId: any) {
        return this.http.get(this.changereceiptsandcancelbill + billId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    upadtereceipt(oldbillId: any, newbillId: any) {
        return this.http.get(this.changereceipts + oldbillId + '/' + newbillId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIpdunbilledChargeserviceslistBychargeId(ipdchargeId: any) {
        return this.http.get(this.IpdunbilledChargeserviceslistBychargeId + 'ipdchargeId=' + ipdchargeId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllautochargeRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.getAutoChargeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getUpadateAutoChargeRecordService(adminsionId: any): Promise<any> {
        return this.http.get(this.updateAutochargeRecord + 'adminsionId=' + adminsionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // saagar pawar code
    getCheckIfBillIsFinalized(admissionId: any): Promise<any> {
        return this.http.get(this.checkIfBillIsFinalized + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // dischargecancelation method
    finalbilltointermediate(admissionId: any): Promise<any> {
        return this.http.get(this.finalBilltoItermediate + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    // finaldate change method
    finalbilldatechange(admissionId: any): Promise<any> {
        return this.http.get(this.finalBilldatechange + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCheckIfBilloutstanding(admissionId: any): Promise<boolean> {
        return this.http.get(this.checkIfBilloutstanding + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getCheckIfBilloutstandingEmg(patientId: any): Promise<boolean> {
        return this.http.get(this.checkIfBilloutstandingEMG + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getservicelistbyadmission(admissionId: any): Promise<any> {
        return this.http.get(this.getallservicebyadmission + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getallservicesDateWise(admissionId: any): Promise<any> {
        return this.http.get(this.GetallservicesDateWise + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getservicelistbyadmission1(admissionId: any): Promise<any> {
        return this.http.get(this.getallservicebyadmission1 + admissionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getchargeservicebychargeid(chargeId: any, serviceid: any): Promise<any> {
        return this.http.get(this.getchargeserviceupdate + '/' + chargeId + '/' + serviceid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    setNewTokenNumber(addedServiceList: any): Promise<any> {
        return this.http.post(this.SetNewTokenNumber, JSON.stringify(addedServiceList), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    selectPackage(key, classId) {
        return this.http.get(this.packageService + key + '/' + classId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    selectPackageByid(key) {
        return this.http.get(this.packageByid + key)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPackageList(key, tariffId) {
        return this.http.get(this.package + key + '/' + tariffId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    modifyRecordService(model: any) {
        return this.http.post(this.ModifyBillRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getOPDBillList(billId: any, unitId: any) {
        return this.http.get(this.GetOPDBillList + billId + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getIPDBillList(billId: any, unitId: any) {
        return this.http.get(this.GetIPDBillList + billId + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPackageView(billId: any) {
        return this.http.get(this.packageView + billId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPackageViewCharge(chargeId: any) {
        return this.http.get(this.packageView1 + chargeId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    setGroupWiseDiscount(groupDisArr: any){
        return this.http.post( this.groupDisAddOrUpdate, groupDisArr, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getGroupWiseDiscount(admissionId: any){
        return this.http.post( this.getGroupDisAdd + "?admissionId=" + admissionId, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getGroupWiseDiscountByBillId(billId: any){
        return this.http.post( this.getGroupDisBillId + "?billId=" + billId, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/tbill-bill/tbill-bill.service.ts